import { apiConfig } from '../../infrastructure/config/api.config';
import { LocalStorageTokenStorage } from '../../infrastructure/storage/local-storage-token-storage';
import { FetchHttpClient } from '../../infrastructure/http/fetch-http-client';
import { IHttpClient } from '../../application/interfaces/http-client.interface';

let sharedHttpClient: IHttpClient | null = null;
let sharedTokenStorage: LocalStorageTokenStorage | null = null;

export const getTokenStorage = (): LocalStorageTokenStorage => {
  if (!sharedTokenStorage) {
    sharedTokenStorage = new LocalStorageTokenStorage();
  }
  return sharedTokenStorage;
};

export const getHttpClient = (): IHttpClient => {
  if (!sharedHttpClient) {
    const storage = getTokenStorage();
    sharedHttpClient = new FetchHttpClient(apiConfig.baseUrl, () => storage.getToken());
  }
  return sharedHttpClient;
};
